<template>
  <ModalBase :show-modal="true" @close-modal="close" width-md class="upload-invoice-modal">
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal">
        <template v-slot:pretitle>
            {{ $gettext('UPLOAD') }}
        </template>
        <template v-slot:title>
          <span v-if="isInvoice">{{ $gettext('New invoice') }}</span>
          <span v-if="isCorrection">{{ $gettext('New correction') }}</span>
        </template>
      </TitleBar>
    </template>
    
    <template v-slot:maincontent>
      <div class="upload-invoice-modal-content">
        <overlay-scrollbars :options="{ scrollbars: { autoHide: 'never' }, overflowBehavior: { y: 'scroll', x: 'hidden' } }">
          <EditInvoiceUploadForm v-if="isInvoice" ref="invoice-upload-form" emit-submit @created="invoiceCreated" />
          <EditCorrectionForm v-if="isCorrection" ref="correction-upload-form" emit-submit @created="invoiceCreated" />
        </overlay-scrollbars>
        
        <!-- <b-tabs class="gk-tabs upload-invoice-tabs" lazy>
          <overlay-scrollbars :options="{ scrollbars: { autoHide: 'never' }, overflowBehavior: { y: 'scroll', x: 'hidden' } }">
            <b-tab :title="$gettext('Single invoice')" :active="isInvoice" @click="uploadInvoiceType = 'invoice'">
              <div class="upload-correction-form">
                <div class="form-intro" v-translate>Upload a single existing invoice into your Gekko account and it will be taken into account as a normal Gekko invoice.</div>
                <EditInvoiceUploadForm ref="invoice-upload-form" emit-submit @created="invoiceCreated" />
              </div>
            </b-tab>
            <b-tab :title="$gettext('Correction')" :active="isCorrection" @click="uploadInvoiceType = 'correction'">
              <div class="upload-correction-form">
                <div class="form-intro" v-translate>Corrections are freeform elements to be uploaded to your invoices in Gekko for multiple reasons. Are you migrating from another accounting platform? You can put the totals in the lines below and add a zip file with all your past invoices. Do you need to offset your invoice totals for whatever reason? Put in the totals in the line and it will be taking into account for all purposes.</div>
                <EditCorrectionForm ref="correction-upload-form" emit-submit @created="invoiceCreated" />
              </div>
            </b-tab>
          </overlay-scrollbars>
        </b-tabs> -->

      </div>
    </template>

    <template v-slot:actions>
      <GekkoButton 
        @click="saveInvoice"
        :text="saveText"
        icon="fa-solid fa-upload"
        type="submit"
        class="float-right position-relative"
        :loading="isWaitingForResponse"
      />
    </template>
  </ModalBase>
</template>

<script>
import { mapGetters } from 'vuex';
import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton";
import ModalBase from "@/components/base_components/ModalBase";
import EditCorrectionForm from "@/components/invoices/EditCorrectionForm"
import EditInvoiceUploadForm from "@/components/invoices/EditInvoiceUploadForm"

export default {
  name: "InvoiceUploadModal",
  components: {
    ModalBase,
    TitleBar,
    GekkoButton,
    EditCorrectionForm,
    EditInvoiceUploadForm
  },
  props: {

  },
  data () {
    return {
      uploadInvoiceType: 'invoice'
    }
  },
  computed: {
    ...mapGetters({
      isWaitingForResponse: 'main/isWaitingForResponse'
    }),
    isCorrection () {
      return this.uploadInvoiceType === 'correction'
    },
    isInvoice () {
      return this.uploadInvoiceType === 'invoice'
    },
    saveText () {
      let text = ''
      if (this.isInvoice) {
        text = this.$gettext('Upload invoice')
      } 
      if (this.isCorrection) {
        text = this.$gettext('Upload correction')
      } 
      return text
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler (to) {
        if (to.meta.uploadType) this.uploadInvoiceType = to.meta.uploadType
      }
    },
  },
  mounted () {
    document.body.classList.add('modal-on')
  },
  methods: {
    close () {
      this.$emit('close')
      document.body.classList.remove('modal-on')
    },
    saveInvoice () {
      if (this.isInvoice) {
        this.$refs['invoice-upload-form'].onSubmit()
      } 
      if (this.isCorrection) {
        this.$refs['correction-upload-form'].onSubmit()
      }
    },
    invoiceCreated () {
      let title_msg = ''
      let text_msg = ''
      if (this.isInvoice) {
        title_msg = this.$gettext("New Invoice")
        text_msg = this.$gettext("Invoice successfully uploaded.")
      } 
      if (this.isCorrection) {
        title_msg = this.$gettext("New Correction")
        text_msg = this.$gettext("Correction successfully uploaded.")
      } 
      this.$store.commit('setAlert', {
        title: title_msg,
        text: text_msg,
        variant: "success",
        duration: 4
      })
      this.$emit('new-item', false)
      this.$store.commit('invoices/REFRESH_INVOICE_LIST')
      this.close()
    },
  }
};
</script>

<style lang="scss" scoped>

</style>

<style lang="scss">
.upload-invoice-modal {
  .upload-invoice-modal-content {
    height: 100%;
    overflow: hidden;
    .upload-correction-form {
      flex-direction: column;
      .form-intro {
        font-size: 14px; color: #808080;
        padding-top: 1rem
      }
    }
    .invoice-wrap {
      padding-top: 0rem;
    }
  }
  .action-buttons-wrapper {
    &.has-actions {
      border-top: 2px solid #dee2e6;
    }
  }
}
</style>
